import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SimulibNavbar from './SimulibNavbar';
import { getWelcomePageData } from './../UserFunctions'
import PropTypes from 'prop-types';

class Welcome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            total_scenario : 0,
            fusa_scenario: 0,
            functional_scenario: 0,
            sotif_scenario: 0
        }
        this.logOut = this.logOut.bind(this);
    }

    logOut() {
        localStorage.removeItem('userToken')
        this.props.history.push('/')
    }


    componentDidMount() {
        getWelcomePageData().then( (response) => {
            if(response.status === 200){
                this.setState( (prevState) => {
                    return{
                        ...prevState,
                        total_scenario: response.data.aggregate_data.total_scenario,
                        fusa_scenario: response.data.aggregate_data.fusa_scenario,
                        functional_scenario: response.data.aggregate_data.functional_scenario,
                        sotif_scenario: response.data.aggregate_data.sotif_scenario
                    }
                })
            }
        })
    }





    render() {
        return (
            <div data-test = 'scenarioCatalogueWelcomeComponent'>
                <div id="purple-background">
                    <SimulibNavbar logOut={this.logOut}/>
                    <div className="container">
                        <div className="row" style={{ paddingTop: "6%" }}>
                            <div className="col-md-12" style={{ textAlign: "center" }}>
                                <h1>Welcome to SimuLib.AD</h1>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: "6%" }}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-body">
                                                <h6 style={{ color: "#753DFF", fontWeight: "bold" }}>Features</h6>
                                                <ol>
                                                    <li>
                                                        Clear diffrentiator between Passenger and Commercial segment.
                                                    </li>
                                                    <li>
                                                        Extensive scenarios not only for Funtional but also for Saftery and Saftey of Intended Functinality(SoTIF).
                                                    </li>
                                                    <li>
                                                        Classification of scenarios based on components, Standards, geography and theme.
                                                    </li>
                                                    <li>
                                                        Smart filter for ease of search.
                                                    </li>
                                                    <li>
                                                        Paramaterization on scenarios for validation coverage(Millions of Runs) and KPIs.
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                        Total Scenario
                                                    </div>
                                                    <Link to="/dashboard_scenario_catalogue" style={{ color: "#464646" }} id="link">
                                                        <div className="card-body" id="welcome-card" style={{ textAlign: "center" }}>
                                                            <p className="card-text" style={{ fontWeight: "900" }} id="value">
                                                                {this.state.total_scenario.toString().padStart(6, '0')}</p>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                    <div className="card">
                                                        <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                            FUSA Scenario
                                                        </div>
                                                        <Link to="/dashboard_scenario_catalogue" style={{ color: "#464646" }} id="link">
                                                            <div className="card-body" id="welcome-card" style={{ textAlign: "center" }}>
                                                                <p className="card-text" style={{ fontWeight: "900" }} id="value">
                                                                    {this.state.fusa_scenario.toString().padStart(6, '0')}</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingTop: "6%" }}>
                                            <div className="col-md-6">
                                                    <div className="card">
                                                        <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                            Functional Scenario
                                                        </div>
                                                        <Link to="/dashboard_scenario_catalogue" style={{ color: "#464646" }} id="link">
                                                            <div className="card-body" id="welcome-card" style={{ textAlign: "center" }}>
                                                                <p className="card-text" style={{ fontWeight: "900" }} id="value">
                                                                    {this.state.functional_scenario.toString().padStart(6, '0')}</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                            </div>
                                            <div className="col-md-6">
                                                    <div className="card">
                                                        <div className="card-header" style={{ backgroundColor: "#757AF7", color: "white" }}>
                                                            SOTIF Scenario
                                                        </div>
                                                        <Link to="/dashboard_scenario_catalogue" style={{ color: "#464646" }} id="link">
                                                            <div className="card-body" id="welcome-card" style={{ textAlign: "center" }}>
                                                                <p className="card-text" style={{ fontWeight: "900" }} id="value">
                                                                    {this.state.sotif_scenario.toString().padStart(6, '0')}</p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
Welcome.propTypes={
history:PropTypes.string,
}
Welcome.defaultProps= {
history:[],

}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };

export default Welcome;
